<template>
  <div :id="componentId" class="sp6-hero-section" :style="sectionStyle">
    <div class="sp6-block_7 flex-row">
      <img
        class="sp6-image_3"
        referrerpolicy="no-referrer"
        :src="imageUrl"
      />
      <div class="sp6-group_1 flex-col">
        <div class="sp6-block_8 flex-row">
          <div class="sp6-box_2 flex-col"></div>
          <span class="sp6-text_22">{{ title }}</span>
          <div class="sp6-box_3 flex-col"></div>
        </div>
        <span class="sp6-text_23">{{ contentWithIndent }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HeroSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_2'
    }
  },
  data() {
    return {
      title: '武\u00A0汉',
      content: '作为宁德核电党委书记、董事长、总经理，田辉宇同志始终牢记嘱托，胸怀"两个大局"，牢记"国之大者"，坚决贯彻落实习近平新时代中国特色社会主义思想，充分发挥企业负责人率先垂范作用，带领公司广大员工奋力拼搏，保障核电安全稳定运营，持续输出绿色清洁能源，为国家双碳目标作出积极贡献。作为宁德核电党委书记、董事长、总经理，田辉宇同志始终牢记嘱托，胸怀"两个大局"，牢记"国之大者"，坚决贯彻落实习近平新时代中国特色社会主义思想，充分发挥企业负责人率先垂范作用，带领公司广大员工奋力拼搏，保障核电安全稳定运营，持续输出绿色清洁能源，为国家双碳目标作出积极贡献。作为宁德核电党委书记、董事长、总经理，田辉宇同志始终牢记嘱托，胸怀"两个大局"，牢记"国之大者"，坚决贯彻落实习近平新时代中国特色社会主义思想，充分发挥企业负责人率先垂范作用，带领公司广大员工奋力拼搏，保障核电安全稳定运营，持续输出绿色清洁能源，为国家双碳目标作出积极贡献。',
      imageUrl: require('../assets/img/FigmaDDSSlicePNGfcc2d8c3ac5a2e301e5bff2331c0665b.png'),
      bgImageUrl: require('../assets/img/FigmaDDSSlicePNG2e04ab22b8b64c961356885edaae1bea.png'),
      bgColor: '#F3F3F3'
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.bgColor,
        backgroundImage: `url(${this.bgImageUrl})`
      };
    },
    contentWithIndent() {
      return '\u3000\u3000' + (this.content || '');
    }
  }
};
</script>
<style scoped>
.sp6-hero-section {
  position: relative;
  width: 2000px;
  height: 580px;
  left: 50%;
  transform: translateX(-50%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 2000px 306px;
}

.sp6-hero-section .sp6-block_7 {
  position: relative;
  width: 1400px;
  height: 522px;
  margin: 0 auto;
  background: none !important;
}

.sp6-hero-section .sp6-image_3 {
  width: 698px;
  height: 414px;
  margin-top: 58px;
  object-fit: cover;
}

.sp6-hero-section .sp6-group_1 {
  width: 703px;
  height: 414px;
  margin-top: 58px;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  padding: 40px 50px;
  box-sizing: border-box;
  overflow: hidden;
}

.sp6-hero-section .sp6-block_8 {
  width: 100% !important;
  height: auto !important;
  margin: 0 !important;
  justify-content: center;
  align-items: center;
}

.sp6-hero-section .sp6-box_2 {
  width: 20px;
  height: 6px;
  margin: 0 16px 0 0;
  align-self: center;
}

.sp6-hero-section .sp6-text_22 {
  width: auto !important;
  height: auto !important;
  white-space: nowrap;
  margin-left: 0 !important;
  line-height: 1;
  color: rgba(52, 54, 56, 1);
  font-size: 40px;
  font-weight: 700;
}

.sp6-hero-section .sp6-box_3 {
  width: 20px;
  height: 6px;
  margin: 0 0 0 16px;
  align-self: center;
}

.sp6-hero-section .sp6-text_23 {
  width: 100% !important;
  height: auto !important;
  margin-top: 20px;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  line-height: 2;
  letter-spacing: 1px;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>